import React, { FunctionComponent } from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  icon: FunctionComponent<React.SVGProps<SVGSVGElement>>;
}

export function Icon(props: IconProps): JSX.Element {
  return <props.icon {...props} />;
}
